import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GreylistAreaRBAC = {
  pageID: '740b50d8518fe2d36f23c2187b140501',
  elementID: {
    ViewPage: '0d495099f84994fd7303944621b1ec4f',
    Detail: 'd53aa0e06d4f28ff641f070e5f149c0e',
    Edit: '3cadbd96ef065c48c4cce9f0ebcd9915',
    Delete: 'd53a7b45ba4f28ff641f070e4f65f150',
    Create: '8784c020824f28ff641ef4160f8bbd51',
    BulkUploadIsochrone: '1ab681058be744c1d8112532f6357d4e',
    BulkUploadCSV: '3cee69ec8b1f1af9add3f4d76a5565ea',
  },
} as const

export const useGreylistAreaRBACPage = createUseRBAC(GreylistAreaRBAC.elementID)

export type UseGreylistAreaRBACPageType = ReturnType<typeof useGreylistAreaRBACPage>
